var _use, _use2, _clipPath, _g, _use3, _clipPath2, _g2, _clipPath3, _g3, _use4, _clipPath4, _g4, _use5, _use6, _use7, _use8, _g5, _g6, _g7, _g8, _clipPath5, _g9, _clipPath6, _g10, _clipPath7, _g11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFdImgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 163 176",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image1",
    x: 0,
    y: 0,
    width: "150px",
    height: "178px",
    transform: "matrix(1.004,0,0,-1.01777,134.491,175.92)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 134.772,
    y: 161.669,
    width: 11.489,
    height: 13.73,
    style: {
      fill: "#f5f5f5"
    }
  }), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image1",
    x: 0,
    y: 0,
    width: "150px",
    height: "178px",
    transform: "matrix(1.004,0,0,-1.01777,16.5312,175.92)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.812,
    y: 161.671,
    width: 11.489,
    height: 13.73,
    style: {
      fill: "#f5f5f5"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.566,0l155.66,0c1.969,0 3.566,1.597 3.566,3.566l0,156.5c0,1.969 -1.597,3.566 -3.566,3.566l-155.66,0c-1.969,0 -3.566,-1.597 -3.566,-3.566l0,-156.5c0,-1.969 1.597,-3.566 3.566,-3.566Z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image3",
    x: 0,
    y: 0,
    width: "2034px",
    height: "2045px",
    transform: "matrix(0.998724,0,0,-0.997756,0,163.632)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M4.687,0.84l153.696,0c1.97,0 3.567,1.597 3.567,3.566l0,153.696c0,1.97 -1.597,3.567 -3.567,3.567l-153.696,0c-1.969,0 -3.566,-1.597 -3.566,-3.567l0,-153.696c0,-1.969 1.597,-3.566 3.566,-3.566Z",
    style: {
      fill: "#fafafa",
      fillRule: "nonzero"
    }
  }), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image4",
    x: 0,
    y: 0,
    width: "1358px",
    height: "1372px",
    transform: "matrix(0.997387,0,0,-0.998509,27.0384,136.594)"
  })), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.224,63.884l34.935,-9.269l4.527,17.062l-34.935,9.269l-4.527,-17.062Z",
    clipRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip5)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image6",
    x: 0,
    y: 0,
    width: "451px",
    height: "220px",
    transform: "matrix(0.970421,-0.257484,-0.2515,-0.947869,115.751,80.946)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M150.343,71.479l-34.395,9.126l-4.383,-16.521l34.394,-9.126l4.384,16.521Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.074,71.235l-32.14,8.528l-4.096,-15.438l32.14,-8.528l4.096,15.438Z",
    style: {
      fill: "#69f0ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.739,66.102c-0.476,-1.793 -3.532,-2.541 -6.82,-1.669c-3.288,0.872 -5.571,3.037 -5.095,4.83c0.476,1.794 3.532,2.542 6.82,1.67c3.288,-0.873 5.57,-3.037 5.095,-4.831Z",
    style: {
      fill: "#fff"
    }
  }), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.273,96.159l5.735,-16.694l34.183,11.743l-5.735,16.694l-34.183,-11.743Z",
    clipRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip7)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image6",
    x: 0,
    y: 0,
    width: "451px",
    height: "220px",
    transform: "matrix(0.949529,0.326208,0.318626,-0.927461,110.273,96.1589)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M144.282,107.546l-33.654,-11.562l5.553,-16.165l33.655,11.562l-5.554,16.165Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.363,106.639l-31.448,-10.804l5.189,-15.105l31.448,10.803l-5.189,15.106Z",
    style: {
      fill: "#69f0ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.239,90.325c-3.217,-1.105 -6.318,-0.578 -6.921,1.177c-0.603,1.755 1.519,4.077 4.736,5.183c3.217,1.105 6.319,0.577 6.922,-1.178c0.602,-1.755 -1.52,-4.077 -4.737,-5.182Z",
    style: {
      fill: "#fff"
    }
  }), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image6",
    x: 0,
    y: 0,
    width: "451px",
    height: "220px",
    transform: "matrix(1.004,0,0,-0.980667,117.643,90.3024)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.924,
    y: 72.931,
    width: 35.585,
    height: 17.093,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.09,
    y: 73.49,
    width: 33.252,
    height: 15.972,
    style: {
      fill: "#69f0ae"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.739,81.336c0,-1.856 -2.761,-3.362 -6.163,-3.362c-3.402,0 -6.163,1.506 -6.163,3.362c0,1.856 2.761,3.362 6.163,3.362c3.402,0 6.163,-1.506 6.163,-3.362Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.878,
    y: 27.878,
    width: 107.033,
    height: 107.033,
    style: {
      fill: "#fff"
    }
  }), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.57,81.396c0,11.142 -9.032,20.174 -20.174,20.174c-11.142,0 -20.174,-9.032 -20.174,-20.174c0,-11.142 9.032,-20.174 20.174,-20.174c11.142,0 20.174,9.032 20.174,20.174Z",
    clipRule: "nonzero"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip8)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image9",
    x: 0,
    y: 0,
    width: "504px",
    height: "504px",
    transform: "matrix(1.00872,0,0,-1.00872,61.2216,101.57)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M100.73,81.396c0,-10.671 -8.663,-19.334 -19.334,-19.334c-10.671,0 -19.334,8.663 -19.334,19.334c0,10.671 8.663,19.334 19.334,19.334c10.671,0 19.334,-8.663 19.334,-19.334Z",
    style: {
      fill: "#fafafa"
    }
  }), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image10",
    x: 0,
    y: 0,
    width: "73px",
    height: "77px",
    transform: "matrix(0.9808,0,0,-1.0272,66.6864,126.084)"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image10",
    x: 0,
    y: 0,
    width: "73px",
    height: "77px",
    transform: "matrix(0.9808,0,0,-1.0272,74.532,126.084)"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image10",
    x: 0,
    y: 0,
    width: "73px",
    height: "77px",
    transform: "matrix(0.9808,0,0,-1.0272,82.3752,126.084)"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image10",
    x: 0,
    y: 0,
    width: "73px",
    height: "77px",
    transform: "matrix(0.9808,0,0,-1.0272,90.2208,126.084)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 66.826,
    y: 120.202,
    width: 5.604,
    height: 5.604,
    style: {
      fill: "#735dd0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.671,
    y: 120.202,
    width: 5.604,
    height: 5.604,
    style: {
      fill: "#735dd0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82.517,
    y: 120.202,
    width: 5.604,
    height: 5.604,
    style: {
      fill: "#735dd0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.362,
    y: 120.202,
    width: 5.604,
    height: 5.604,
    style: {
      fill: "#735dd0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88.158,72.96l-0.918,-0.643l2.249,-3.212l0.918,0.643l-2.249,3.212Z",
    style: {
      fill: "#735dd0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.832,88.157l0.643,-0.918l3.212,2.249l-0.643,0.918l-3.212,-2.249Z",
    style: {
      fill: "#735dd0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.633,89.831l0.918,0.643l-2.249,3.212l-0.918,-0.643l2.249,-3.212Z",
    style: {
      fill: "#735dd0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.961,74.634l-0.643,0.918l-3.212,-2.249l0.643,-0.918l3.212,2.249Z",
    style: {
      fill: "#735dd0"
    }
  }), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.148,72.927l-0.918,-0.643l2.249,-3.212l0.918,0.643l-2.249,3.212Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.823,88.124l0.643,-0.918l3.212,2.25l-0.643,0.918l-3.212,-2.25Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.625,89.797l0.918,0.643l-2.249,3.212l-0.918,-0.643l2.249,-3.212Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.952,74.601l-0.643,0.918l-3.212,-2.249l0.643,-0.918l3.212,2.249Z"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.583,81.396c0,6.731 -5.456,12.187 -12.187,12.187c-6.731,0 -12.187,-5.456 -12.187,-12.187c0,-6.731 5.456,-12.187 12.187,-12.187c6.731,0 12.187,5.456 12.187,12.187Z",
    clipRule: "nonzero"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip11)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image12",
    x: 0,
    y: 0,
    width: "304px",
    height: "304px",
    transform: "matrix(1.0156,0,0,-1.0156,69.2088,93.5832)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M92.885,81.396c0,-6.341 -5.148,-11.489 -11.489,-11.489c-6.341,0 -11.489,5.148 -11.489,11.489c0,6.341 5.148,11.489 11.489,11.489c6.341,0 11.489,-5.148 11.489,-11.489Z",
    style: {
      fill: "#735dd0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.01,82.937c-0.005,-4.1 2.176,-7.892 5.723,-9.949c3.547,-2.057 7.921,-2.068 11.477,-0.028c-3.2,-3.08 -7.889,-4.039 -12.041,-2.462c-4.152,1.576 -7.024,5.404 -7.374,9.832c-0.351,4.427 1.883,8.66 5.735,10.87c-2.25,-2.16 -3.521,-5.144 -3.52,-8.263Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  })), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.503,71.17l-8.966,0l0,-22.388c0.001,-0.48 0.391,-0.868 0.871,-0.868l7.226,0c0.482,0 0.872,0.39 0.872,0.871l-0.003,22.385Z",
    clipRule: "nonzero"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip13)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image14",
    x: 0,
    y: 0,
    width: "112px",
    height: "290px",
    transform: "matrix(0.996533,0,0,-1.01113,23.5368,71.1696)"
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.589,115.159l-7.138,0c-0.505,0 -0.914,-0.409 -0.914,-0.914l0,-22.342l8.966,0l0,22.337c0.001,0.243 -0.094,0.477 -0.266,0.65c-0.172,0.172 -0.405,0.269 -0.648,0.269Z",
    clipRule: "nonzero"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip15)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image14",
    x: 0,
    y: 0,
    width: "112px",
    height: "290px",
    transform: "matrix(0.996268,0,0,-1.01113,23.5368,115.159)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M24.576,48.192l6.886,0c0.42,0 0.76,0.341 0.76,0.761l0,21.655l-8.4,0l0,-21.648c-0.004,-0.42 0.334,-0.764 0.754,-0.768Z",
    style: {
      fill: "#fafafa",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.815,92.184l8.4,0l0,22.159c0,0.141 -0.114,0.255 -0.254,0.255l-7.889,0c-0.141,0 -0.254,-0.114 -0.254,-0.255l0,-22.159l-0.003,0Z",
    style: {
      fill: "#fafafa",
      fillRule: "nonzero"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    id: "_Image1",
    width: "12px",
    height: "14px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAuElEQVQokZWRQXLDMAwDlzSUX/Vp/rhFCbnYbh1n0gmOqwFIQrGu609EmF22sR2Z+ZYpIjpARFBVAEhizklmMsbA9slkuyIC2yzLgm3mnBwsMwFOJtvdPqfzd413TJlZt5cPku3+mhIRt+SDqaqqtUZEsG3bb5JEZlJVzDkBWJYFSRp7bUi6JB9NHYcDaO721hq9X7bj8XhcpgLo+KAxxiUJoKpuTK8H/idV1b3wT4bW2neG3vtXhic8XHzChsqWCwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "_Image3",
    width: "163px",
    height: "164px",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "_Image4",
    width: "109px",
    height: "110px",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "_Image6",
    width: "36px",
    height: "18px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAASCAYAAAAzI3woAAAACXBIWXMAAA7EAAAOxAGVKw4bAAABpUlEQVRIic2WWZLbMAxEu8FFp8rRfHCLJDofFlS0JHsmk0rK+KIeUCIIYiFvt9svkjAzAYC7UxK+ywAgpQQAumKSKAmSYGYg+ZIBQCbZzQyS4O4AAJIgeckAYIzxloUEm22/YlnSmMF2LMRJf8KOzgT/Dstm1vFBkgGML63+o+TW2sg5I+csABhjsLWGlBJKKU/MzFBr3Vnvj+DWWrXlAscYkIRaK0hqjEF3xxgDy7KApNyd7o7eO2qtMLO9ILKZdXfHuq67l5HkRwbgiUUCt9aeTknyxMzsksWh9gjh066M5Gc59GlVZu4uktoSS3h03J2FhG5mIVv33m2CbQm868xs3yd0MzMzZXffuzGAfT2zo+4oc3MLmys2F8QVW9cVOeesea7EzHrH5pFxZLF2928z4FFx7g6LVh8bxyav2DY0n8ZGtITZ9k/Y7GDuvWv2cJaU0mnW/A272iOc2W0ihCRVStH0DUk4Mnf/MYv/RVTi2kspSimJ5COHZo+P3/+CpZROzMxgZsqtNb0L8fGJsT3Szs+GnE9joJRyGhfLsuB+v79kvwHWvAyUOIlu+QAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "_Image9",
    width: "40px",
    height: "40px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAAA7EAAAOxAGVKw4bAAACs0lEQVRYhdWYYXLjIAyFn4Tc9FR7tR47rTF6+yOIEpu47Xany76ZTDIfRggkBI68vLz8IikAoKoEAJIIJiIUkWAVfZ1Vu0MGgKo6ZAbAAUg1fHviJiEJEemx8DbKp1j93WBMes+qw0Nmld/NKp77LotoNK9F+FVmIuIVtgZ3l0cMeE+FzzKSEg58wNoqBzMA3uVNm8EjBgCllMNM/xKr6J2Zu9/FZr/c/5q1EM8qQ7ejZtT8KzjKwZlkJOdewelDHPVoVsVZPK2Mo+o4kdomSSm14yUUV6DdkQcRgbufskc2zQzbtn3IlmVBzhnWH9SqephBDL7X6Nk9G9l090+xUgpU9T/YxSR9FEpVPYRscO9rrG8bsTMb+7H6lFF3p4gwpUR3bx8RoZmR5CkDcGAkaWYEcGAicsrcnSmlxh6WmViBn9BZIbG6cgBuu67vFIl6xoBbQovIXf/Yvd9lx604mVqZmVW2riuA7xXqR/2/WpR7PT09YV1XWIC9cQAHJwAcHD7rv3fkEds7BwCxcPPnYEpp7hz8qVr3p5o+xNqHuB4x7Ru47eQRi8+IRSEXkSELWyO298deX1+B+m5sZnB31h1EAHh+foa7o3/ucrmAZNtpwK0siAje3t4aW5YFqhp9Y1CklLCua3NEVXG5XHpGEYGZvZcZALher4cl7o2HeidCvbOhnPOhhJRSDuO4+4GRxPV6nT8HzcxYShGSMDO6u6jqkLm7uHvLk3qi3LFQKUVq7vX/ijUWNrdtk8i9EbMa67vErJ4fWEqJ/a3jEQPe/9+LiexZ2FyW5ZRNH+L5Hcw5U1VpZsw5EwBzzu16v20bSba2mrN099ZW85SllNYWrwHbtrW2eA3IObe2uPL3Y5sZVfX2G7gvG1EW+rIRN5BR2di2bXhD6ctG3HR6Fn16FrZ79hufI3rrtbrBqgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "_Image10",
    width: "6px",
    height: "6px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAVUlEQVQImV2MUQrDMAzFZMckd+rhcuuOBGK/fa2U6VdCNue8JAlAkkWEJFlU1YcX5xwAwsxuAHenqp4geu8LIDMfMcYg1lrFH3tvwt3VWiMz+S0l8QV1biySfg+JJQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "_Image12",
    width: "24px",
    height: "24px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAA7EAAAOxAGVKw4bAAABKUlEQVRIibWVS46DQAxEy5/mVnM2jp1FsCsb3NODQog0tCUEekYUNmUj67r+YGJ4ZuZUAVUNkgAAEemJu5gDyDFZcRdzknFM1BvcwZxkujsyExHxm3AHSWzb9pGZGUQEz+fzLXMz699AVfuZJEheMgDIzFPmJIOkAOBY5gcGEeHAdvSeeUTMt+lYloj8acMVExGIyClzEcmjl+vGb1i15Yx5lHVmtWhZlgSAiOg2XZalt6Is+YmR7DY9Mo+IPhlmhhK7iykAZib3ncc6SN7CvMrdhY4t/DdzVeUxc2d4eXuagLvPreDxeMx8PrS11hdaa42qiivm7jQzVu6MmRm9kqVoZvyGlZiZsWbgHdNxv9T1Fav4hvm2bRynUFX7z0JETtm4YWtzlsDIXorKdKYZU/AuAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "_Image14",
    width: "9px",
    height: "23px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAXCAYAAADZTWX7AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAA1klEQVQokZWSXXLEIAyDZVk5Vs+Wc2fAdh92IaSzU1o/MR/+kcB2nucXNiEAUVUGAGZW42Jlysw0MwBAZs7qlUlSbMflWv6bpm1SROw7HccREYGquqGEzJxGlJlhZtMNcLsk+Q9Nvfe/uZMEM0NrDSSRmXB3kETvHZKUAFBVkPTQUlVwd8jd6y3WSNY6ZjBd1zXYI2FllFTDvrsXSfxkGodROtZlZdzZBwC11srdAQAR97uShJm99mkc3qNuxVXzPyXpk6tHcN05kvPFRxczgyKiVi2f4hse5IIVRwrdEQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFdImgBank);
export default __webpack_public_path__ + "static/media/fd_img_bank.4ed5b2ce.svg";
export { ForwardRef as ReactComponent };